import { render, staticRenderFns } from "./saveOrUpdateSysExamRoomLook.vue?vue&type=template&id=5b21ab41&scoped=true&"
import script from "./saveOrUpdateSysExamRoomLook.vue?vue&type=script&lang=js&"
export * from "./saveOrUpdateSysExamRoomLook.vue?vue&type=script&lang=js&"
import style0 from "./saveOrUpdateSysExamRoomLook.vue?vue&type=style&index=0&id=5b21ab41&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b21ab41",
  null
  
)

export default component.exports